import { ReactElement } from 'react';
import { BlueCircle, ConsumptionContainer } from './styles';
import { formatNumber } from '../../helpers';
import { useTranslation } from 'react-i18next';
import { GraphTooltip } from 'pages/NewOverview/components/GraphTooltip';
import { formatNumberWithFractionDigits } from '~/helpers/thousandFormatNumber';

interface WaterTooltipGraphProps {
  date: string;
  value: number;
  unit: string;
  type: 'day' | 'month';
}

export function WaterTooltipGraph({
  date,
  value,
  unit,
  type,
}: Readonly<WaterTooltipGraphProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <GraphTooltip
      date={date}
      type={type}
    >
      <ConsumptionContainer>
        <BlueCircle />
        <span>{t('Consumo')}</span>
        <span>
          {formatNumberWithFractionDigits(value, { minimum: 0, maximum: 2 })}
          {' '}
          {unit}
        </span>
      </ConsumptionContainer>
    </GraphTooltip>
  );
}
